<template lang="pug">
.search-result-student
  pulldown-select.search-result-student__action(v-model='selectedGrade', :selectOptions='gradeSelectOptions')
  textbox-search.search-result-student__action(v-model='fullNameValue', :placeholder='fullNamePlaceholder')
  textbox-search.search-result-student__action(v-model='statusValue', :placeholder='statusPlaceholder')
  button-search.search-result-student__action(@click='searchEvent')
    slot(name='searchButtonText')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import PulldownSelect from '@/components/molecules/manager/PulldownSelect.vue'
import TextboxSearch from '@/components/molecules/manager/TextboxSearch.vue'
import ButtonSearch from '@/components/molecules/manager/ButtonSearch.vue'
import { InputItem } from '@/models/inputItem'

/**
 * 教室絞り込み
 */
@Component({
  components: {
    PulldownSelect,
    TextboxSearch,
    ButtonSearch,
  },
})
export default class SearchResultStudent extends Vue {
  // 学年選択オプション
  @Prop()
  gradeSelectOptions!: InputItem[]

  // 学年選択値
  @Prop()
  gradeValue!: string

  // 氏名
  @Prop()
  fullName!: string

  // ステータス
  @Prop()
  status!: string

  // 氏名プレースホルダー
  @Prop()
  fullNamePlaceholder!: string

  // ステータスプレースホルダー
  @Prop()
  statusPlaceholder!: string

  // 学年変更時イベント
  @Prop()
  gradeChangeEvent!: Function

  // 氏名変更時のイベント
  @Prop()
  fullNameChangeEvent!: Function

  // ステータス変更時のイベント
  @Prop()
  statusChangeEvent!: Function

  // 検索イベント
  @Prop()
  searchEvent!: Function

  /*
   * 入力値ゲッター・セッター
   */
  // 学年
  get selectedGrade(): string {
    return this.gradeValue
  }
  set selectedGrade(value: string) {
    this.gradeChangeEvent(value)
  }
  // 氏名
  get fullNameValue(): string {
    return this.fullName
  }
  set fullNameValue(value: string) {
    this.fullNameChangeEvent(value)
  }
  // ステータス
  get statusValue(): string {
    return this.status
  }
  set statusValue(value: string) {
    this.statusChangeEvent(value)
  }
}
</script>

<style lang="stylus" scoped>
.search-result-student
  display flex

  &__action
    margin 7px 5px
</style>
